<template>
  <div class="home">

    <Topside />

    <div style="position: relative; float:left;">
      <img src="../assets/img/top.jpg" width="950" height="440" alt="メイン画像" style="margin-bottom:16px;">
      <p class="moji1">沖縄関係外交史料館資料データベース</p>
      <p class="moji2">監修：我部政明</p>
    </div>

    <div class="main">
      <div class="news" style="margin:auto;">
        <div class="boxtitle">沖縄関係外交史料館資料データベースについて</div>

        <div v-html="contentsData.Content1"></div>
      </div>
		    
      <div class="news">
        <div class="boxtitle">お知らせ</div>
        <!--<div class="box-3" style="white-space: pre-wrap;" v-html="contentsData.Content2"></div>-->

        <ul>
          <li><div v-html="contentsData.Content2"></div></li>
        </ul>

		  </div>
		
	  </div>


  </div>
</template>

<style lang="css">
/*お知らせbox*/
.box-3 {
    height: 140x;
	  padding: 10px 20px;
}
</style>

<script>
import Topside from '@/components/Treeside.vue'

// @ is an alias to /src
import axios from 'axios'
export default {
  name: 'home',

  components: {
    Topside
  },
  computed: {
    /**
      * コンテンツの取得
      */
    contentsData() {
      return this.$store.getters.content
    }
  },
  created: function() {
    var self = this
    self.init()
  },

  
  data () {
    return {
     }
  },
  mounted: function () {
    var self = this
    self.init()

    
  },
  methods: {
    init () {
      this.getAllKaisoData(function(res){})
    },
  }
}
</script>
